import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { waLink, STORE } from "@/config";

export const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      {open && (
        <div className="w-72 rounded-2xl bg-white shadow-2xl border border-[#E7E0D6] overflow-hidden" data-testid="whatsapp-widget">
          <div className="bg-[#075E54] text-white px-4 py-3">
            <p className="font-semibold text-sm">Sonia Dry Fruits Jammu</p>
            <p className="text-xs text-white/70">Typically replies within minutes</p>
          </div>
          <div className="p-4">
            <div className="rounded-xl bg-[#F3ECE2] p-3 text-sm text-[#1F130B]">
              Namaste! 🌰 Welcome to Sonia Dry Fruits. How can we help you order premium Kashmiri dry fruits today?
            </div>
            <a
              href={waLink("Hi! I'd like to order premium Kashmiri dry fruits.")}
              target="_blank"
              rel="noreferrer"
              data-testid="whatsapp-widget-chat"
              className="mt-3 block text-center rounded-full bg-[#25D366] text-white font-semibold py-2.5 text-sm hover:brightness-95"
            >
              Start Chat
            </a>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="whatsapp-float-btn"
        className="h-14 w-14 grid place-items-center rounded-full bg-[#25D366] text-white shadow-xl wa-pulse hover:scale-105 transition-transform"
        aria-label="WhatsApp"
      >
        {open ? <X size={26} /> : <MessageCircle size={28} />}
      </button>
    </div>
  );
};
